import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './Widgets/LoginPage';
import Dashboard from './Widgets/Dashboard';
import ClassPage from './Widgets/ClassPage';
import PrivateRoute from './Widgets/PrivateRoute';
import NetworkManager from './Widgets/Network';
import AdminPage from './Widgets/AdminPage';
import WorkflowsPage from './Widgets/WorkflowsPage';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route - accessible without login */}
        <Route path="/" element={<LoginPage />} />

        {/* Protected routes - only accessible with a token */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/class/:classId"
          element={
            <PrivateRoute>
              <ClassPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/network"
          element={
            <PrivateRoute>
              <NetworkManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/workflows"
          element={
            <PrivateRoute>
              <WorkflowsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
